import React, { useState, useEffect, useRef } from 'react';
import './ProductPage.css';
import { FaSearch } from 'react-icons/fa';
import { FiEdit2 } from 'react-icons/fi';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { buildApiUrl, getAuthHeaders } from '../../config/api';
import { useRestaurant } from '../../context/RestaurantContext';
import { notify, confirm } from '../../context/FeedbackContext';
import { getFilteredNavItemsWithIcons, getRouteFromItem } from '../../config/routes';

function RefId({ value }) {
  const [copied, setCopied] = React.useState(false);
  if (!value) return <div className="product-ref-id">-</div>;
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="product-ref-id ref-id-wrapper" onClick={handleCopy} style={{ cursor: 'pointer', position: 'relative', display: 'inline-block' }}>
      <span>ID: {value.slice(0, 8)}...</span>
      <span className="ref-id-tooltip">{copied ? 'Copied!' : value}</span>
    </div>
  );
}

function ProductPage({ onNavigate }) {
  const { selectedRestaurant } = useRestaurant() || {};
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSeasonal, setSelectedSeasonal] = useState('All');
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  // 打印机列表
  const [prinList, setPrinList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  const fetchProducts = async (page, search, seasonal, status, tenantRef) => {
    setLoading(true);
    try {
      const body = { currentPage: page };
      if (search) body.keyword = search;
      if (seasonal !== 'All') body.seasonal = seasonal === 'seasonal' ? 1 : 0;
      if (status !== 'All') body.status = status === 'Published' ? 1 : 0;
      if (tenantRef) body.tenantReference = tenantRef;

      if (tenantRef == null) {
        return
      }

      const res = await fetch(buildApiUrl('/product/productList'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.code === 200) {
        setProducts(data.data.list || []);
        setTotalCount(data.data.totalCount || 0);
        setPageSize(data.data.pageSize || 10);
      }
    } catch (err) {
      console.error('Failed to fetch products', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProducts(currentPage, searchTerm, selectedSeasonal, selectedStatus, selectedRestaurant?.reference);
    }, searchTerm ? 400 : 0);
    return () => clearTimeout(timer);
  }, [currentPage, searchTerm, selectedSeasonal, selectedStatus, selectedRestaurant]); // eslint-disable-line react-hooks/exhaustive-deps

  const [showAddDropdown, setShowAddDropdown] = useState(false);
  const addDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (addDropdownRef.current && !addDropdownRef.current.contains(e.target)) {
        setShowAddDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    getPrintIn(selectedRestaurant?.reference);
    getDevice(selectedRestaurant?.reference);

  }, [selectedRestaurant]);


  const handleNavClick = (item) => {
    if (onNavigate) {
      onNavigate(getRouteFromItem(item));
    }
  };


  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentProducts = products;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleProductDetail = (product) => {
    setSelectedProduct(product);
    setShowDetailModal(true);
  };


  // 查询打印机
  const getPrintIn = async (tenantRef) => {
    if (!tenantRef) return;
    try {
      const res = await fetch(
        buildApiUrl(`/setting/printers/by-tenant?tenantReference=${tenantRef}`),
        { headers: getAuthHeaders() }
      );
      const data = await res.json();
      if (data.code === 200) {
        setPrinList(data.data);
      }
    } catch (err) {
      notify(err, 'error');
      console.error("Failed to fetch printers", err);
    }
  };
  // 获取设备
  const getDevice = async (tenantRef) => {
    if (!tenantRef) return;
    try {
      const res = await fetch(
        buildApiUrl(`/tenant/device/by-tenant?tenantReference=${tenantRef}`),
        { headers: getAuthHeaders() }
      );
      const data = await res.json();
      if (data.code === 200) {
        setDeviceList(data.data);
      }
    } catch (err) {
      notify(err, 'error');
      console.error("Failed to fetch devices", err);
    }
  };

  const handleTrainingAi = (e) => {
    console.log("训练AI按钮点击事件", e);
  }

  const handleDeleteProduct = async (productId) => {
    if (await confirm('Are you sure you want to delete this product?')) {
      try {
        // 这里应为删除单个产品的API
        const response = await fetch(buildApiUrl(`/api/products/${productId}`), {
          method: 'DELETE'
        });
        if (response.ok) {
          setProducts(products.filter(p => p.id !== productId));
          notify('Product deleted successfully!', 'success');
        } else {
          throw new Error('Failed to delete product');
        }
      } catch (error) {
        console.error('删除产品时出错:', error);
        notify(`Failed to delete product: ${error.message}`, 'error');
      }
    }
  };

  // const getCategoryColor = (category) => {
  //   const colors = {
  //     'noodle': '#ff6b6b',
  //     'rice': '#4ecdc4',
  //     'chicken': '#45b7d1',
  //     'seafood': '#96ceb4',
  //     'drink': '#feca57'
  //   };
  //   return colors[category] || '#95a5a6';
  // };

  // const getStatusColor = (status) => {
  //   switch (status) {
  //     case 'published': return 'green';
  //     case 'draft': return 'orange';
  //     case 'archived': return 'red';
  //     case 'scheduled': return 'blue';
  //     default: return 'gray';
  //   }
  // };

  const { items: navItems, icons: navIcons } = getFilteredNavItemsWithIcons();

  return (
    <div className="productpage-container">
      <nav className="sidebar">
        <div className="sidebar-title">Restaurant Management</div>
        <ul>
          {navItems.map(item =>
          (
            <li
              key={item}
              className={item === 'Product' ? 'active' : ''}
              onClick={() => handleNavClick(item)}
            >
              <span className="nav-icon">{navIcons[item]}</span> {item}
            </li>
          )
          )}
        </ul>
      </nav>

      <main className="productpage-main">
        <div className="productpage-header">
          <div className="header-left">
            <h1>Products</h1>
            <p>Manage your restaurant products</p>
          </div>
          <div className="header-right" ref={addDropdownRef} style={{ position: 'relative' }}>

            <HasPermi permission={['product:simple:add']}>
              <button className="add-product-btn" onClick={() => setShowAddDropdown(prev => !prev)}>
                + Add Product ▾
              </button>
            </HasPermi>

            {showAddDropdown && (
              <div className="add-product-dropdown">
                <button className="add-product-dropdown-item" onClick={() => { setShowAddDropdown(false); onNavigate('ProductForm'); }}>
                  Simple Product
                </button>
                <button className="add-product-dropdown-item" onClick={() => { setShowAddDropdown(false); onNavigate('ConfigurableProductForm'); }}>
                  Configurable Product
                </button>
                <button className="add-product-dropdown-item" onClick={() => { setShowAddDropdown(false); onNavigate('BundleProductForm'); }}>
                  Bundle Product
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="productpage-content">
          {/* Filters */}
          <div className="filters">

            <div className="search-box">
              <FaSearch className="search-icon-input" />
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              />
            </div>
            {deviceList.length > 0 && (
              <button className="add-product-btn" onClick={(e) => handleTrainingAi(e)}>
                Training AI
              </button>
            )}
            <div className="filter-options">
              <span className="filter-label">Seasonal</span>
              <select value={selectedSeasonal} onChange={(e) => { setSelectedSeasonal(e.target.value); setCurrentPage(1); }}>
                <option value="All">All</option>
                <option value="regular">Regular</option>
                <option value="seasonal">Seasonal</option>
              </select>
              <span className="filter-label">Status</span>
              <select value={selectedStatus} onChange={(e) => { setSelectedStatus(e.target.value); setCurrentPage(1); }}>
                <option value="All">All</option>
                <option value="Published">Published</option>
                <option value="Unpublished">Unpublished</option>
              </select>
            </div>
          </div>

          {/* Products Table */}
          <div style={{ overflowX: 'auto' }}>
            <table className="products-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th></th>
                  <th>Product Name</th>
                  <th>Product Description</th>
                  <th>Category</th>
                  <th>Base Price</th>
                  <th>Membership Price</th>
                  <th>Seasonal</th>
                  <th>Status</th>
                  <th>Printer</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {loading
                  ? Array.from({ length: 5 }).map((_, i) => (
                    <tr key={`skeleton-${i}`}>
                      <td><Skeleton width={30} /></td>
                      <td><Skeleton width={44} height={44} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={180} /></td>
                      <td><Skeleton width={60} /></td>
                      <td><Skeleton width={50} /></td>
                      <td><Skeleton width={50} /></td>
                      <td><Skeleton width={60} /></td>
                      <td><Skeleton width={70} /></td>
                      <td><Skeleton width={70} /></td>
                      <td></td>
                    </tr>
                  ))
                  : currentProducts.map((product, idx) => {
                    const isPublished = product.status === 1;
                    return (
                      <tr key={product.reference || `product-${idx}`}>
                        <td className="product-id-cell"><RefId value={product.reference} /></td>
                        <td className="product-img-cell">
                          {product.itemPic && product.itemPic !== 'undefined' && product.itemPic !== '' ? (
                            <img
                              className="product-thumb"
                              // src={buildApiUrl(`/file/view?fileName=${product.itemPic.split('/').pop()}`)}
                              src={product.itemPic}
                              alt={product.itemName}
                            />
                          ) : (
                            <div className="product-thumb-placeholder">
                              {/* 无图片 */}
                              <span></span>
                            </div>
                          )}
                        </td>

                        {/* <td className="product-img-cell">
                          <img
                            className="product-thumb"
                            src={
                              product.itemPic && product.itemPic !== 'undefined' 
                                ? buildApiUrl(`/file/view?fileName=${product.itemPic.split('/').pop()}`)
                                : ''
                            }
                            alt={product.itemName}
                          />
                        </td> */}
                        <td className="product-name-cell">
                          <span className="product-name-text">{product.itemName}</span>
                        </td>
                        <td>{product.itemDesc || '-'}</td>
                        <td>{product.catName || '-'}</td>
                        <td>{product.basePrice !== null ? Number(product.basePrice).toFixed(2) : '-'}</td>
                        <td>{product.memberPrice !== null ? Number(product.memberPrice).toFixed(2) : '-'}</td>
                        <td className="seasonal-cell">
                          <span className={`product-badge ${product.seasonal === 1 ? 'badge-blue' : 'badge-green'}`}>
                            {product.seasonal === 1 ? 'Seasonal' : 'Regular'}
                          </span>
                        </td>
                        <td className="status-cell">
                          <span className={`product-badge ${isPublished ? 'badge-green' : 'badge-red'}`}>
                            {isPublished ? 'Published' : 'Unpublished'}
                          </span>
                        </td>
                        {/* 打印机 */}
                        <td>
                          {prinList.find(p => p.reference === product.printerReference)?.printerName || ''}
                        </td>
                        <td>
                          <HasPermi permission={['product:simple:edit']}>
                            <button className="table-edit-btn" onClick={() => {
                              const page = product.itemType === 1 ? 'ConfigurableProductEdit' : product.itemType === 2 ? 'BundleProductEdit' : 'ProductEdit';
                              onNavigate(page, product);
                            }}><FiEdit2 /></button>
                          </HasPermi>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>

        </div>

        {/* Pagination - outside the card, flushed bottom right */}
        {!loading && (
          <div className="pagination">
            <button className="pg-arrow" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>&#8249;</button>
            {(() => {
              if (totalPages <= 7) {
                return Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <button key={page} onClick={() => handlePageChange(page)} className={currentPage === page ? 'pg-num active' : 'pg-num'}>{page}</button>
                ));
              }
              const pages = [];
              pages.push(<button key={1} onClick={() => handlePageChange(1)} className={currentPage === 1 ? 'pg-num active' : 'pg-num'}>1</button>);
              if (currentPage > 3) pages.push(<span key="dots1" className="pg-dots">•••</span>);
              for (let p = Math.max(2, currentPage - 1); p <= Math.min(totalPages - 1, currentPage + 1); p++) {
                pages.push(<button key={p} onClick={() => handlePageChange(p)} className={currentPage === p ? 'pg-num active' : 'pg-num'}>{p}</button>);
              }
              if (currentPage < totalPages - 2) pages.push(<span key="dots2" className="pg-dots">•••</span>);
              pages.push(<button key={totalPages} onClick={() => handlePageChange(totalPages)} className={currentPage === totalPages ? 'pg-num active' : 'pg-num'}>{totalPages}</button>);
              return pages;
            })()}
            <button className="pg-arrow" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>&#8250;</button>
          </div>
        )}
      </main>

      {/* 产品详情模态框 */}
      {showDetailModal && selectedProduct && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{selectedProduct.name}</h2>
              <button
                className="close-btn"
                onClick={() => setShowDetailModal(false)}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="product-detail-image">
                <img
                  src={
                    selectedProduct.image ||
                    (selectedProduct.media_gallery_entries && selectedProduct.media_gallery_entries.length > 0
                      ? 'https://order-dev.posjoy.com/pub/media/catalog/product' + selectedProduct.media_gallery_entries[0].file
                      : '/images/default-product.jpg')
                  }
                  alt={selectedProduct.name}
                />
              </div>

              <div className="product-detail-info">
                <p><strong>Description:</strong> {selectedProduct.description}</p>
                <p><strong>Price:</strong> ${selectedProduct.price}</p>
                <p><strong>Category:</strong> {selectedProduct.category}</p>
                <p><strong>Status:</strong> {selectedProduct.status || 'published'}</p>
                <p><strong>Created:</strong> {new Date(selectedProduct.created_at).toLocaleDateString()}</p>
                <p><strong>Member Price:</strong> {selectedProduct.membership_enabled ? `¥${selectedProduct.membership_price}` : 'Disabled'}</p>
                <p><strong>Promo Code:</strong> {selectedProduct.promo_code}</p>
                <p><strong>Visibility:</strong> {selectedProduct.visibility === 'visible' ? 'Visible' : 'Hidden'}</p>
                <p><strong>Seasonal:</strong> {selectedProduct.seasonal === 'seasonal' ? 'Seasonal' : 'Regular'}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductPage; 